// Third-party Libraries
import { connect } from 'react-redux';
import get from 'lodash/get';
// Our code
import CompareByCategoryContentPage from '../pages/CompareByCategory/CompareByCategoryPage';
import { fetchDeviceSuggestionsStart } from '../api/actions/device-suggestions';
import {
  getDeviceSearchUIState,
  getDeviceSuggestionsAreVisible,
  getIsSearchHintVisible,
} from '../api/selectors/view-state/device-search';
import {
  blurDeviceSearchInput,
  focusDeviceSearchInput,
  hideDeviceSearch,
  setDeviceSearchInputValue,
  showDeviceSearch,
} from '../api/actions/ui';
import { makeScreenReaderAnnouncement } from '../api/actions/ui';
import { requestRoute } from '../api/actions/navigation';
import { RootState } from '../api/store-types';

const mapStateToProps = (state: RootState) => ({
  deviceSuggestions: state.deviceSuggestions.data || [],
  deviceSearchInputValue: state.ui.deviceSearchInputValue,
  deviceSearchIsActive: state.ui.showDeviceSearch,
  deviceSearchUIState: getDeviceSearchUIState(state),
  deviceSuggestionsAreVisible: getDeviceSuggestionsAreVisible(state),
  isSearchHintVisible: getIsSearchHintVisible(state),
  planDownloadSpeed: get(state, 'network.planSpeed', ''),
});

const actionCreators = {
  blurDeviceSearchInput,
  focusDeviceSearchInput,
  fetchDeviceSuggestionsStart,
  hideDeviceSearch,
  makeScreenReaderAnnouncement,
  requestRoute,
  setDeviceSearchInputValue,
  showDeviceSearch,
};

export default connect(
  mapStateToProps,
  actionCreators
)(CompareByCategoryContentPage);
